import { Config } from "@config";
import type { EventComponentType, GA4EventParameters } from "@utils/google-analytics-4.type";
import autobind from "autobind-decorator";
import type { PureMeasureComponentProps, PureMeasureComponentState } from "./PureMeasureComponent";
import { PureMeasureComponent } from "./PureMeasureComponent";

export type MeasureComponentProps = PureMeasureComponentProps;

export interface MeasureComponentState extends PureMeasureComponentState {
	wasVisible: boolean;
}

export abstract class MeasureComponent<
	Props extends MeasureComponentProps = MeasureComponentProps,
	State extends MeasureComponentState = MeasureComponentState,
> extends PureMeasureComponent<Props, State> {
	protected readonly productTypes: string;
	protected readonly componentType: EventComponentType;

	public constructor(props) {
		super(props);

		this.state = this.getInitialState();
	}

	protected getInitialState(): State {
		return { wasVisible: Config.isSsr() } as unknown as State;
	}

	public componentDidMount(): void {
		const { ga4Event } = this.props;

		// Ha van szülő nem küldünk eseményt
		if (!ga4Event?.instanceId) {
			this.sendEvent("BM_componentCreate");
		}
	}

	protected getCommonEventParameters(): Partial<GA4EventParameters> {
		return {
			productTypes: this.productTypes,
			componentType: this.componentType,
			...super.getCommonEventParameters(),
		};
	}

	@autobind
	protected onVisibilityChange(isVisible: boolean): void {
		if (isVisible) {
			this.setState({
				wasVisible: true,
			});

			this.sendEvent("BM_componentImpression");
		}
	}
}
